export function SET_TEXT(text) {
    return {
        type: 'SET_TEXT',
        payload: text
    }
}

export function SET_IMAGE(image) {
    return {
        type: 'SET_IMAGE',
        payload: image
    }
}
export function RESET_COMPOSER() {
    return {
        type: 'RESET_COMPOSER',
        payload: null
    }
}